import {
  GET_DASHBOARD_CANCELLED_TASKS,
  GET_DASHBOARD_CANCELLED_TASKS_SUCCESS,
  GET_DASHBOARD_CANCELLED_TASKS_ERROR,
} from './actionTypes';

const initialState = {
  errorGetDashboardCancelledTasks: '',
  loadingGetDashboardCancelledTasks: false,
  tasks: null,
  successGetDashboardCancelledTasks: '',
};

const getDashboardCancelledTasks = (state = initialState, action) => {
  switch (action.type) {
    case GET_DASHBOARD_CANCELLED_TASKS:
      state = { ...state, loadingGetDashboardCancelledTasks: true };
      break;
    case GET_DASHBOARD_CANCELLED_TASKS_SUCCESS:
      state = {
        ...state,
        loadingGetDashboardCancelledTasks: false,
        tasks: action.payload.tasks,
        successGetDashboardCancelledTasks: action.payload.message,
      };
      break;
    case GET_DASHBOARD_CANCELLED_TASKS_ERROR:
      state = { ...state, errorGetDashboardCancelledTasks: action.payload, loadingGetDashboardCancelledTasks: false };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default getDashboardCancelledTasks;
